import { render, staticRenderFns } from "./LoginWeixin.vue?vue&type=template&id=166cf2ab&scoped=true&"
import script from "./LoginWeixin.vue?vue&type=script&lang=js&"
export * from "./LoginWeixin.vue?vue&type=script&lang=js&"
import style0 from "./LoginWeixin.vue?vue&type=style&index=0&id=166cf2ab&prod&scoped=true&lang=css&"
import style1 from "./LoginWeixin.vue?vue&type=style&index=1&id=166cf2ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166cf2ab",
  null
  
)

export default component.exports